// extracted by mini-css-extract-plugin
export default {"container":"agGrid_container__Fn5Qz","pivot":"agGrid_pivot__r80+3"};